import React from 'react';

const RenderFields = ({
  fields,
  formData,
  handleChange,
  readOnly = false,
  fieldTransformers = {},
  validationErrors = {},
}) => {
  return fields.map((field) => {
    if (field.type === 'select' && field.options) {
      // Use RenderFieldsDropdown for select fields
      return (
        <RenderFieldsDropdown
          key={field.key}
          fields={[field]} // Pass the single dropdown field as an array
          formData={formData}
          handleChange={handleChange}
          readOnly={readOnly}
          validationErrors={validationErrors}
        />
      );
    }

    // Handle standard fields
    return (
      <div key={field.key} className="flex flex-col w-full mb-4">
        <div className="flex justify-between items-center w-full pb-2">
          <label
            className={`relative font-semibold p-2 w-1/5 flex items-center`}
            style={{ minWidth: '160px' }}
          >
            {field.label}
            <span className="flex-grow border-dotted border-b-4 border-gray-200 m-2"></span>
          </label>
          <input
            type={field.type || 'text'}
            name={field.key}
            className={`border ${
              validationErrors[field.key] ? 'border-red-500' : 'border-gray-300'
            } flex-grow p-2 rounded-md my-auto ${readOnly ? 'bg-gray-100' : ''}}`}
            value={
              fieldTransformers[field.key]
                ? fieldTransformers[field.key](formData[field.key])
                : formData[field.key] || ''
            }
            onChange={handleChange}
            readOnly={readOnly}
          />
        </div>
        {validationErrors[field.key] && (
          <div className="text-red-500 text-sm mt-1 ml-2">
            {validationErrors[field.key]}
          </div>
        )}
      </div>
    );
  });
};

const RenderFieldsDropdown = ({
  fields,
  formData,
  handleChange,
  readOnly = false,
  validationErrors = {},
}) => {
  return fields.map((field) => (
    <div key={field.key} className="flex flex-col w-full mb-4">
      <div className="flex justify-between items-center w-full pb-2">
        <label
          className={`relative font-semibold p-2 w-1/5 flex items-center`}
          style={{ minWidth: '160px' }}
        >
          {field.label}
          <span className="flex-grow border-dotted border-b-4 border-gray-200 m-2"></span>
        </label>
        <select
          name={field.key}
          className={`border ${
            validationErrors[field.key] ? 'border-red-500' : 'border-gray-300'
          } flex-grow p-2 rounded-md my-auto ${
            readOnly ? 'bg-gray-100' : ''
          }`}
          value={formData[field.key] || ''}
          onChange={handleChange}
          disabled={readOnly}
        >
          <option value="">Select an option</option>
          {field.options &&
            field.options.map((option) => (
              <option key={option.key} value={option.key}>
                {option.label} {/* This line ensures the label is shown in the dropdown */}
              </option>
            ))}
        </select>
      </div>
      {validationErrors[field.key] && (
        <div className="text-red-500 text-sm mt-1 ml-2">
          {validationErrors[field.key]}
        </div>
      )}
    </div>
  ));
};

export { RenderFields, RenderFieldsDropdown };
